import React from 'react';

import { AspectRatio, Box, Flex, Image, Paper, PaperProps, Space, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { YoutubeVideo } from 'shared/interfaces/Youtube';

interface YoutubeVideoProps extends PaperProps {
  video: YoutubeVideo;
  isSelected: boolean;
  onVideoSelect: (youtubeVideo: YoutubeVideo) => void;
}

export function YoutubeVideoComponent({ video, onVideoSelect, isSelected, ...paperProps }: YoutubeVideoProps) {
  const { t } = useTranslation();

  return (
    <Paper
      mt={10}
      mb={10}
      h={90}
      withBorder
      sx={(theme) => ({
        position: 'relative',
        opacity: video.captionsAvailable ? 1 : 0.5,
        border: `1px solid ${isSelected ? theme.colors.dark[9] : theme.colors.gray[3]}`,
        ':hover': {
          cursor: 'pointer',
          backgroundColor: theme.colors.gray[0]
        }
      })}
      {...paperProps}>
      <Flex
        direction="row"
        align="center"
        sx={() => ({
          position: 'relative'
        })}
        p={10}
        onClick={() => video.captionsAvailable && onVideoSelect(video)}>
        <Space w={6} />
        <AspectRatio ratio={16 / 9} miw={110}>
          <Paper radius={5}>
            <Image fit="cover" src={video.imageUrl} withPlaceholder />
          </Paper>
        </AspectRatio>
        <Space w={17} />
        <Box maw={600}>
          <Text size="md" lineClamp={2}>
            {video.title}
          </Text>
          <Text size="md" lineClamp={1}>
            {video.channelTitle}
          </Text>
        </Box>
        {!video.captionsAvailable && (
          <Text mr={7} mt={7} sx={{ position: 'absolute', top: 0, right: 0 }}>
            {t('BATCH_RESOURCE_SELECTOR.YOUTUBE.NO_CAPTIONS')}
          </Text>
        )}
      </Flex>
    </Paper>
  );
}
